// extracted by mini-css-extract-plugin
module.exports = {" _key":"sitepen-site/App","root":"App-m__root__f52bc3LaFAR"};